import type { ChatStore } from "../Store";
import type { BotStageAnswerCreationQuery } from "@/Modules/Models/Domain/FlexoBot";

import { hasValue } from "@/Utils/Objects";
import FlexoApiConnector from "@/Services/TherapyApi/Flexo";
import type { BotStageAnswerApiCreationQuery } from "@/Modules/Models/Api/FlexoBot";

class CreateBotStageAnswerActionHandler {
  constructor(
    private readonly chatStore: ChatStore,
    private readonly botApiConnector = new FlexoApiConnector()
  ) {}

  public async handle(value: string): Promise<void> {
    this.chatStore.isStartingAnswer = true;

    if (hasValue(this.chatStore.botStage) && hasValue(this.chatStore.botStage.id)) {
      const botStageAnswerCreationQuery: BotStageAnswerCreationQuery = {
        stageId: this.chatStore.botStage.id,
        value,
      };

      const botStageAnswerApiCreationQuery =
        this.transformBotStageAnswerCreationQueryToBotStageAnswerApiCreationQuery(
          botStageAnswerCreationQuery
        );

      await this.botApiConnector.createAnswers(botStageAnswerApiCreationQuery);
    }
  }
  private transformBotStageAnswerCreationQueryToBotStageAnswerApiCreationQuery(
    botStageAnswerCreationQuery: BotStageAnswerCreationQuery
  ): BotStageAnswerApiCreationQuery {
    const botStageAnswerApiCreationQuery: BotStageAnswerApiCreationQuery = {
      stage_uuid: botStageAnswerCreationQuery.stageId,
      value: botStageAnswerCreationQuery.value,
    };

    return botStageAnswerApiCreationQuery;
  }
}

export default CreateBotStageAnswerActionHandler;
